import React, { useEffect, useRef, useState } from 'react'

import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { Box, Container } from '@mui/material'
import Grid from '@mui/material/Grid'
import { getSnapshot } from 'mobx-state-tree'

import { useStores } from '@trivie/core'
import { StepsList } from '../content-creation/components/steps-list'
import { StepPanel } from '../content-creation/components/step-drawer'
import ContentCreationHeader from '../content-creation/content-creation-header'
import { PathSettings } from './components/path-settings'
import ContentCreationHeaderTitle from '../content-creation/content-creation-header-title'

const _isEqual = require('lodash/isEqual')

export const CreatePathScreen = observer((props: { edit?: boolean }) => {
  const { pathStore } = useStores()
  const { edit } = props
  const { workflow, createWorkflow, path, createPath } = pathStore

  const history = useHistory()

  const [showStepPanel, setShowStepPanel] = useState(false)
  const [pathSnapshot, setPathSnapshot] = useState<any>()

  const handleBack = async () => {
    if (edit) {
      history.goBack()
    } else {
      history.push('/content/paths')
    }
  }

  const handleAddStep = () => {
    setShowStepPanel(true)
    if (!workflow) {
      createWorkflow()
    }
    if (workflow?.editing) {
      workflow?.setEditing('')
      workflow?.selectStep(undefined)
    }
  }

  useEffect(() => {
    if (!path) {
      createPath()
    } else {
      setPathSnapshot(getSnapshot(path))

      // Hydrate Section Header display nodes if path has node_groups
      if (path.workflow_json?.node_groups?.length > 0) {
        path.workflow_json.hydrateNodeGroups()
      }

      if (workflow?.stub) {
        workflow?.removeAction(workflow?.stub)
      }
    }
  }, [])

  useEffect(() => {
    if (path?.name) {
      path.workflow_json.setName(`${path.name} - Workflow`)
    }
  }, [path?.name])

  return (
    <>
      <ContentCreationHeader
        style={{ position: 'absolute', left: 0, top: 0, width: '100%' }}
        editingPath={edit}
        onBack={handleBack}
        showUnsavedPopup={!_isEqual(path ? getSnapshot(path) : {}, pathSnapshot)}
        publishData={path}
        titleHeader={
          <ContentCreationHeaderTitle
            titles={[{ title: path?.name || 'Untitled Learning Path', isPlaceholder: !path?.name }]}
          />
        }
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        right={0}
        bgcolor={'rgb(244, 244, 244)'}
        overflow="auto"
        paddingTop="70px"
      >
        <Container sx={{ width: '100%' }} maxWidth="xl" disableGutters>
          <Box p={6} sx={{ flexDirection: 'row' }}>
            <Grid container spacing={2}>
              <Grid size={{ sm: 12, md: 5, lg: 4 }}>
                <PathSettings />
              </Grid>
              <Grid size={{ sm: 12, md: 7, lg: 8 }}>
                <StepsList
                  edit={edit}
                  workflow={workflow}
                  path={path}
                  showStepPanel={showStepPanel}
                  handleAddStep={handleAddStep}
                />
              </Grid>
            </Grid>
          </Box>
          <StepPanel
            workflow={workflow}
            open={showStepPanel}
            onOpen={() => setShowStepPanel(true)}
            onClose={() => setShowStepPanel(false)}
          />
        </Container>
      </Box>
    </>
  )
})
